import { safeSourceUrls, type PublicArticle } from "@workspace/public-seo";

export function GuideEditorialDetails({ article }: { article: PublicArticle }) {
  const sources = safeSourceUrls(article.sourceUrls);
  return <section aria-label="文章發布及參考資料" className="rounded-lg border bg-secondary/20 p-4 text-sm space-y-2 my-5">
    <p>發布平台：Skoltend{article.authorName ? ` · 作者／編輯：${article.authorName}` : ""}</p>
    {article.updatedAt && <p className="text-muted-foreground">內容更新：{new Date(article.updatedAt).toLocaleDateString("zh-HK", { timeZone: "Asia/Hong_Kong" })}</p>}
    {article.reviewedAt && <p>最後審閱：{article.reviewedAt}</p>}
    {sources.length > 0 && <div><h2 className="font-medium">參考來源</h2><ul className="list-disc pl-5">
      {sources.map(url => <li key={url} className="break-all"><a href={url} target="_blank" rel="noopener noreferrer" className="text-primary underline">{url}</a></li>)}
    </ul></div>}
    <p className="text-xs text-muted-foreground">本文為一般參考資料，並非官方公告或法律意見；請核對教育局最新指引及個別學校文件。未填寫的作者或審閱日期不會自動推定。</p>
  </section>;
}
